import { X } from "lucide-react";
import React, { useEffect, useState } from "react";

function InstallPWA() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showInstall, setShowInstall] = useState(false);
  const [showIosGuide, setShowIosGuide] = useState(false);

  // Detect iOS
  const isIos = /iphone|ipad|ipod/.test(
    window.navigator.userAgent.toLowerCase()
  );
  const isPWAInstalled =
    window.matchMedia("(display-mode: standalone)").matches ||
    window.navigator.standalone === true;

  useEffect(() => {
    const isSecure =
      window.location.protocol === "https:" ||
      window.location.hostname === "localhost";
    if (!isSecure) return;

    if (isIos) {
      // iOS: Show guide only if not installed and not already dismissed
      if (!isPWAInstalled && !sessionStorage.getItem("pwaPromptShownIos")) {
        setShowIosGuide(true);
        sessionStorage.setItem("pwaPromptShownIos", "true");
      }
      return;
    }

    // Windows/Android: use beforeinstallprompt
    if (sessionStorage.getItem("pwaPromptShown")) return;

    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowInstall(true);
      sessionStorage.setItem("pwaPromptShown", "true");
    };

    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, [isIos, isPWAInstalled]);

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    console.log("User response:", outcome);
    setDeferredPrompt(null);
    setShowInstall(false);
  };

  const handleClose = () => {
    setShowInstall(false);
    setShowIosGuide(false);
  };

  if (isPWAInstalled) return null;

  return (
    <>
      {/* Windows/Android Install Prompt */}
      {showInstall && (
        <div className="fixed bottom-4 right-4 bg-white shadow-xl p-4 sm:p-5 rounded-2xl max-w-sm sm:max-w-md w-[90%] sm:w-auto z-[9999]">
          <button
            onClick={handleClose}
            className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
            aria-label="Close"
          >
            <X size={18} />
          </button>
          <h3 className="text-lg sm:text-xl font-semibold text-gray-800">
            📲 Install School ERP
          </h3>
          <p className="text-sm sm:text-base text-gray-600 mt-1">
            Add School ERP to your device for faster access to classes, attendance, and reports.
          </p>
          <button
            className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg mt-3 w-full text-sm sm:text-base"
            onClick={handleInstall}
          >
            Install Now
          </button>
        </div>
      )}

      {/* iOS Guide */}
      {showIosGuide && (
        <div className="fixed bottom-4 right-4 bg-white shadow-xl p-4 sm:p-5 rounded-2xl max-w-sm sm:max-w-md w-[90%] sm:w-auto z-[9999]">
          <button
            onClick={handleClose}
            className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
            aria-label="Close"
          >
            <X size={18} />
          </button>
          <h3 className="text-lg sm:text-xl font-semibold text-gray-800">
            📲 Add to Home Screen
          </h3>
          <p className="text-sm sm:text-base text-gray-600 mt-1">
            To install School ERP on iPhone or iPad, open in Safari, tap the <strong>Share</strong> button (square with an up arrow) and select <strong>Add to Home Screen</strong>.
          </p>
        </div>
      )}
    </>
  );
}

export default InstallPWA;
